import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const DateRangeIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="#e8eaed"
    >
      <path d="M316.19-400.72q-18.21 0-30.55-12.32t-12.34-30.53q0-18.21 12.32-30.67t30.54-12.46q18.21 0 30.55 12.46 12.33 12.46 12.33 30.67t-12.32 30.53q-12.32 12.32-30.53 12.32Zm163.83 0q-18.22 0-30.55-12.32-12.34-12.32-12.34-30.53t12.32-30.67q12.32-12.46 30.53-12.46 18.22 0 30.55 12.46 12.34 12.46 12.34 30.67t-12.32 30.53q-12.32 12.32-30.53 12.32Zm163.82 0q-18.21 0-30.55-12.32-12.33-12.32-12.33-30.53t12.32-30.67q12.32-12.46 30.53-12.46t30.55 12.46q12.34 12.46 12.34 30.67t-12.32 30.53q-12.32 12.32-30.54 12.32ZM202.87-71.87q-37.78 0-64.39-26.61t-26.61-64.39v-554.26q0-37.78 26.61-64.39t64.39-26.61H240v-37.37q0-17.96 12.46-30.29 12.45-12.34 30.41-12.34t30.29 12.34q12.34 12.33 12.34 30.29v37.37h309v-37.37q0-17.96 12.46-30.29 12.45-12.34 30.41-12.34t30.29 12.34Q720-863.46 720-845.5v37.37h37.13q37.78 0 64.39 26.61t26.61 64.39v554.26q0 37.78-26.61 64.39t-64.39 26.61H202.87Zm0-91h554.26V-560H202.87v397.13Zm0-477.13h554.26v-77.13H202.87V-640Zm0 0v-77.13V-640Z" />
    </SvgIcon>
  );
};
